import { PageTitle } from '../../../_metronic/layout/core';
import BackButton from '../../components/BackButton/BackButton';
import { useEffect } from 'react';
import { useAuth } from '../../../app/modules/auth';

const EmpresasDashboardPage = () => {

	const { isAdminRole, isEmployerRole, auth } = useAuth();
	const dashEmpresa = process.env.REACT_APP_DASH_EMPRESA || '';
	const dashEmpresaFilterFieldId = process.env.REACT_APP_DASH_EMPRESA_FILTER_FIELD_ID || '';


	/**
	 * Retorna url para llamado a dashboard en looker studio	
	 */
	const url = () => {
		if (isAdminRole()) {
			return dashEmpresa;
		} else if (isEmployerRole()) {
			/**
			 *  Generacion de un marcador personalizado
			 *  Documentación: https://support.google.com/looker-studio/answer/7664330?hl=en#zippy=%2Cin-this-article
			 * 	Ejemplo: La siguiente linea hace referencia a la aplicacion de un filtro por el atributo idhashempresa
			 *	`%7B%22df215%22:%22include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580${idHash}%22%7D` 
			 */
			return `${dashEmpresa}?params=%7B%22${dashEmpresaFilterFieldId}%22:%22include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580${auth?.user?.idHash}%22%7D`
		} else {
			return ``
		}
	}

	useEffect(() => {

	}, []);

	/**
	 * Valida si es administrador o empresa
	 * @returns 
	 */
	const isAdminOrEmployer = () => {
		return isAdminRole() || isEmployerRole();
	}

	return (
		<>
			<div className='p-10 shadow-4 rounded-3 mt-15' style={{ backgroundColor: '#FFFF' }}>
				<div className='row mb-4'>
					<div className='col-sm-12'>
						<div className='input-group d-flex' style={{ width: '100%' }}>
							<div
								className='col-sm-1'
								style={{
									display: 'contents',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<BackButton to='/' />
							</div>
							<div className='col-sm-10' style={{ padding: '0px 0px 0px 10px' }}>
								<p>Métricas e indicadores de las vacantes y candidatos</p>
							</div>
						</div>
					</div>
				</div>
				<div style={{ width: '100%' }}>
					{isAdminOrEmployer() && (
						<iframe
							width="100%"
							height='850px'
							frameBorder="0"
							style={{ border: '0' }}
							allowFullScreen
							src={url()}
						>
						</iframe>
					)}
				</div>
			</div>
		</>
	);
};

const EmpresasDashboardWrapper = () => {
	return (
		<>
			<PageTitle breadcrumbs={[]}>Empresas</PageTitle>
			<EmpresasDashboardPage />
		</>
	);
};

export { EmpresasDashboardWrapper };
